module.exports = __webpack_public_path__ + "assets/img/bebb65eed61538646d86d48e7bbafecd.png";